import { useState } from 'react'
import { api } from '../lib/api.js'
import { useAuth } from '../lib/auth.jsx'
import { Card, Field, KV, Page, SubmitButton, useConfirm, useToast } from '../components/Ui.jsx'
import { fmtStamp } from '../lib/format.js'

export default function Account () {
  const { user } = useAuth()
  const toast = useToast()
  const confirm = useConfirm()
  const [form, setForm] = useState({ current: '', next: '', confirm: '' })
  const [busy, setBusy] = useState(false)

  const submit = async e => {
    e.preventDefault()
    if (form.next !== form.confirm) return toast.error('New password and confirmation do not match')
    const ok = await confirm({
      title: 'Change your password?',
      body: 'You will need the new password from now on, and the admin can no longer read it back to you if you forget it — they can only issue a fresh one.',
      confirmLabel: 'Change password',
      tone: 'danger'
    })
    if (!ok) return
    setBusy(true)
    try {
      const res = await api.post('/auth/change-password', { current: form.current, next: form.next })
      toast.ok(res.message)
      setForm({ current: '', next: '', confirm: '' })
    } catch (err) {
      toast.error(err.message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <Page title="My account" subtitle="Change the password the admin issued to you. Once you set your own, the admin can no longer read it.">
      <div className="grid two">
        <Card title="Sign-in details">
          <KV items={[
            { k: 'Username', v: <span className="mono">{user?.username}</span> },
            { k: 'Role', v: user?.role },
            { k: 'Name on the account', v: user?.displayName },
            { k: 'Last sign-in', v: fmtStamp(user?.lastLoginAt) }
          ]} />
        </Card>

        <Card title="Change password">
          <form onSubmit={submit}>
            <Field label="Current password" required>
              <input type="password" value={form.current} onChange={e => setForm({ ...form, current: e.target.value })} required />
            </Field>
            <Field label="New password" required hint="At least 6 characters.">
              <input type="password" minLength={6} value={form.next} onChange={e => setForm({ ...form, next: e.target.value })} required />
            </Field>
            <Field label="Confirm new password" required>
              <input type="password" minLength={6} value={form.confirm} onChange={e => setForm({ ...form, confirm: e.target.value })} required />
            </Field>
            <SubmitButton busy={busy} type="submit">Update password</SubmitButton>
          </form>
        </Card>
      </div>
    </Page>
  )
}
